import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesTicketCompany = ({data}) => {
  return (
       <SupportServicesTable data={data} />
  );
};

export default SupportServicesTicketCompany;
